// extracted by mini-css-extract-plugin
module.exports = {"seeLiveProject2":"Projects-module--seeLiveProject2--2-LE_","sourceCodeProject2":"Projects-module--sourceCodeProject2--2JPnW"};